// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

export const WebpIconsStepGroup: FunctionComponent = ({ children }) => {
    return <Container>{children}</Container>;
};
